export default IconZip => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-zip" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M16 16v-8h2a2 2 0 1 1 0 4h-2" />
  <path d="M12 8v8" />
  <path d="M4 8h4l-4 8h4" />
</svg>`;